import { render, staticRenderFns } from "./LOL.vue?vue&type=template&id=575b4a15&scoped=true"
import script from "./LOL.vue?vue&type=script&lang=js"
export * from "./LOL.vue?vue&type=script&lang=js"
import style0 from "./LOL.vue?vue&type=style&index=0&id=575b4a15&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b4a15",
  null
  
)

export default component.exports